import React, { FC, useContext } from 'react'
import { Box, Button, CircularProgress } from '@mui/material'
import BookingContext from '../contexts/booking'

const BookingPayment: FC<React.PropsWithChildren<unknown>> = () => {
  const booking = useContext(BookingContext)

  return (
    <Box sx={{ 
      display: 'flex',
      p: 2,
    }}>
      <Box sx={{
        width: '100%',
        p: 3,
      }}>
        <Box sx={{ my: 2 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            disabled={booking.loading}
            onClick={() => {
              booking.pay()
            }}
          >
            Pay With Stripe
          </Button>
        </Box>
        {booking.loading && (
          <Box sx={{ my: 2 }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default BookingPayment